<template>
  <div>
    <fidelior-title text="Profile" />
    <div role="tablist">
      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-account
            variant="default"
            class="text-left font-weight-bold"
          >User Account Information</b-button>
        </b-card-header>
        <b-collapse id="accordion-account" visible accordion="my-accordion" role="tabpanel">
          <b-form @submit="save">
            <b-card-body class="container-fluid">
              <div class="row">
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-first-name"
                    label="First name"
                    label-for="input-first-name"
                  >
                    <b-form-input id="input-first-name" v-model="account.firstName"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-last-name"
                    label="Last name"
                    label-for="input-last-name"
                  >
                    <b-form-input id="input-last-name" v-model="account.lastName"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <b-form-group id="input-group-email" label="E-mail" label-for="input-email">
                    <b-form-input id="input-email" v-model="account.email" type="email" readonly></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <fidelior-role v-model="account.primaryRole" />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <fidelior-areas v-model="account.areas" />
                </div>
                <div class="col-sm-6"></div>
              </div>
              <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                  <b-button
                    class="float-right mt-3"
                    variant="danger"
                    type="submit"
                    :disabled="working"
                  >
                    <font-awesome-icon icon="circle-notch" class="fa-spin" v-if="working" />Save
                  </b-button>
                </div>
              </div>
            </b-card-body>
          </b-form>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-payment
            variant="default"
            class="text-left font-weight-bold"
          >Payment Information</b-button>
        </b-card-header>
        <b-collapse id="accordion-payment" accordion="my-accordion" role="tabpanel">
          <b-card-body></b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-statistics
            variant="default"
            class="text-left font-weight-bold"
          >Defined Usage Statistics</b-button>
        </b-card-header>
        <b-collapse id="accordion-statistics" accordion="my-accordion" role="tabpanel">
          <b-card-body></b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      working: false,
      account: {
        firstName: "",
        lastName: "",
        email: "",
        primaryRole: "",
        areas: []
      }
    };
  },
  methods: {
    save(evt) {
      evt.preventDefault();
    }
  }
};
</script>